import React from "react";
import NavItems from "./app-nav-items.js";
import { ConnectionStatusIndicator } from "../shared/";

export default class NavPanel extends React.Component {
	render() {
		return (
			<div className="ambifiSideNav">
				<NavItems onFilter={this.props.onFilter} onFilterEnd={this.props.onFilterEnd} />
				<div className="ambifiSideNavStatus">
					<ConnectionStatusIndicator />
				</div>
			</div>
		);
	}
}
